//var base_url = "http://localhost/fondo/web/bundles/imaginarifondo/json/";
// var base_url = "http://192.168.100.2/assets/";

var global_countries, global_provinces, global_municipalities, global_cuba;

Window.prototype.sortIt = function ( id )
{
    var select = $('#' + id);
    select.html(select.find('option').sort(function(x,y){
        return $(x).text() > $(y).text() ? 1 : -1;
    }));
}

Window.prototype.populateMunicipalities = function(stateElementId, regionElementId) {

    var selectedCountryIndex = 55;
    var selectedStateIndex = document.getElementById(stateElementId).value;
    var municipalityElement = document.getElementById(regionElementId);

    var urlAdd;
    // If Cuba, well, load Cuba then
    if (selectedCountryIndex == 55)
    {
        municipalityElement.length = 0;
        municipalityElement.options[0] = new Option('--', '');
        municipalityElement.selectedIndex = 0;

        for (var i = 0; i < global_provinces.length; i++) {
          let region = global_provinces[i];
          if (region['province']['id'] == selectedStateIndex) {
            municipalityElement.options[municipalityElement.length] =
              new Option(region['name'], region['id']);
          }
    }
    } else {
        municipalityElement.length = 0;
        municipalityElement.options[0] = new Option('--', '');
        municipalityElement.selectedIndex = 0;

        var pos = 0;
        for (var i = 0; i < global_municipalities.countries.length; i++) {
            if (global_municipalities.countries[i].c_id == selectedCountryIndex) {
                municipalityElement.options[municipalityElement.length] = new Option(global_municipalities.countries[i].name, pos);
                pos++;
            }
        }

    }

    sortIt(regionElementId);
}

Window.prototype.populateStates = function(stateElementId, regionElementId)
{
  var stateElement = document.getElementById(stateElementId);

  stateElement.length = 0;
  stateElement.options[0] = new Option('--', '');
  stateElement.selectedIndex = 0;

  // extract provinces
  let provinces = [];

  for (var i = 0; i < global_provinces.length; i++) {
    let p = global_provinces[i]['province'];
    provinces[p['id']] = p['name'];
  }

  provinces.forEach(function callback(value, index) {
    stateElement.options[stateElement.length] = new Option(value, index);
  });

  if (regionElementId) {
      stateElement.onchange = function() {
          populateMunicipalities(stateElementId, regionElementId);
      };

      populateMunicipalities(stateElementId, regionElementId);
  }

  sortIt(stateElementId);
}

Window.prototype.getCountryName = function(countryId)
{
  for (var i = 0; i < global_countries.countries.length; i++) {
      if (global_countries.countries[i].id == countryId) {
          return global_countries.countries[i].name;
      }
  }

  return " ";
}

Window.prototype.getProvinceName = function(countryId, municipalityId) {
    for (var i = 0; i < global_provinces.regions.length; i++) {
        if (global_provinces.regions[i].id == countryId) {
            var region = global_provinces.regions[i];
            for (var j = 0; j < region.regions.length; j++) {
                if (region.regions[j].id == municipalityId) {
                    return region.regions[j].name;
                }
            }
        }
    }

    return " ";
}

Window.prototype.getMunicipalityName = function(provinceId, cityId, countryId) {

    if (countryId == 55) {
        for (var i = 0; i < global_cuba.countries.length; i++) {
            if (global_cuba.countries[i].id == countryId) {
                var region = global_cuba.countries[i];
                for (var j = 0; j < region.regions.length; j++) {
                    if (region.regions[j].id == provinceId) {
                        var municipality = region.regions[j];

                        for (var z = 0; z < municipality.municipalities.length; z++) {
                            if (municipality.municipalities[z].id == cityId) {
                                return municipality.municipalities[z].name;
                            }
                        }
                    }
                }
            }
        }
    } else {
        var pos = 0;
        for (var i = 0; i < global_municipalities.countries.length; i++) {
            if (global_municipalities.countries[i].c_id == countryId) {
                if (pos == cityId) {
                    return global_municipalities.countries[i].name;
                }
                pos++;
            }
        }

    }

    return " ";
}

var maxRegionLoaded = 4;
var regionDataLoaded = 0;

Window.prototype.loadRegionData = function(base_url, country, province, municipality)
{
  $.ajax({
      url: base_url,
      success: function(result) {
          global_cuba = result;
          regionDataLoaded++;
      }
  });
}

Window.prototype.loadSelectedRegionData = function(base_url, provinceElementId,
    regionElementId, province, region)
{
  $.ajax({
      url: base_url,
      success: function(result) {
          global_provinces = result;
          regionDataLoaded++;

          populateStates(provinceElementId, regionElementId);
          document.getElementById(provinceElementId).value = province;
          document.querySelector('#' + provinceElementId).dispatchEvent(new Event('change'));
      }
  });
}

Window.prototype.loadCountryOnly = function(base_url, el_id, coutry) {
    $.ajax({
        url: base_url.concat("countries.json"),
        success: function(result) {
            global_countries = result;

            if ( el_id != null )
            {
                document.getElementById(el_id).innerHTML = getCountryName( coutry );
            }
        }
    });
}

Window.prototype.loadProvinceOnly = function(base_url, el_id, province, country) {

    $.ajax({
        url: base_url.concat("cuba.json"),
        success: function(result) {
            global_cuba = result;
            regionDataLoaded++;

            $.ajax({
                url: base_url.concat("regions.json"),
                success: function(result) {
                    global_provinces = result;

                    if ( el_id != null )
                    {
                        document.getElementById(el_id).innerHTML = getProvinceName( country, province );
                    }
                }
            });

        }
    });
}

